import type React from 'react'
import {Modal} from 'pepsico-ds'
import type {IModalProps} from 'pepsico-ds'

const ModalWrapper: React.FC<IModalProps> = props => {
  return <Modal {...props} />
}

export default ModalWrapper
